import type { FixedTermMarket } from '@/utils/internalAppSdk'
import { sortObjectsByKey } from '@vaultsfyi/common/utils'

export type FixedTermSortBy = 'expiry' | 'fixedApy' | 'tvl'
export type FixedTermSortOrder = 'asc' | 'desc'

export const sortFixedTermMarkets = (
  markets: FixedTermMarket[],
  sortBy: FixedTermSortBy,
  sortOrder: FixedTermSortOrder
) => {
  const asc = sortOrder === 'asc'

  switch (sortBy) {
    case 'tvl':
      return sortObjectsByKey(markets, ['tvl', 'usd'], asc, (tvl) => Number(tvl))
    case 'fixedApy':
    case 'expiry':
      return sortObjectsByKey(markets, [sortBy], asc)
  }
}
